"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrashIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var TrashIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("g", { fill: "none" },
        React.createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M6,9 L6,20.5263161 C6,20.788737 6.223,21 6.5,21 L17.5,21 C17.777,21 18,20.788737 18,20.5263161 L18,9 L6,9 Z M8.5,11 C8.77615,11 9,11.210682 9,11.4705875 L9,18.5294125 C9,18.789318 8.77615,19 8.5,19 C8.22385,19 8,18.789318 8,18.5294125 L8,11.4705875 C8,11.210682 8.22385,11 8.5,11 Z M12,11 C12.5523,11 13,11.210682 13,11.4705875 L13,18.5294125 C13,18.789318 12.5523,19 12,19 C11.4477,19 11,18.789318 11,18.5294125 L11,11.4705875 C11,11.210682 11.4477,11 12,11 Z M15.5,11 C15.77615,11 16,11.210682 16,11.4705875 L16,18.5294125 C16,18.789318 15.77615,19 15.5,19 C15.22385,19 15,18.789318 15,18.5294125 L15,11.4705875 C15,11.210682 15.22385,11 15.5,11 Z" }),
        React.createElement("path", { fill: "currentColor", d: "M11,3 L13,3 C13.5522847,3 14,3.44771525 14,4 L10,4 L10,4 C10,3.44771525 10.4477153,3 11,3 Z" }),
        React.createElement("rect", { width: "14", height: "3", x: "5", y: "5", fill: "currentColor", rx: "1" })))); };
exports.TrashIcon = TrashIcon;
